import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

export const BestsellerChip: FC<ChipProps> = ({
  className,
  size = 'small',
}) => {
  const { t } = useTranslation()

  return (
    <Chip className={className} color="blue" size={size}>
      {t('common:WB_BESTSELLERS_LABEL', { count: 1 })}
    </Chip>
  )
}
